import { dateTimeText, fromWall, wallDate } from '../../lib/time.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- mail-team-bar ---
let __fez_component_0;
{
// Preset snooze times on the person's clock: worked out on a wall Date, then read back as an instant.
function snoozeTime(preset) {
  const at = wallDate(new Date())
  at.setUTCSeconds(0, 0)
  if (preset === 'today') {
    if (at.getUTCHours() < 15) at.setUTCHours(18, 0)
    else at.setUTCHours(at.getUTCHours() + 3, 0)
  } else if (preset === 'tomorrow') {
    at.setUTCDate(at.getUTCDate() + 1)
    at.setUTCHours(8, 0)
  } else if (preset === 'weekend') {
    at.setUTCDate(at.getUTCDate() + ((6 - at.getUTCDay() + 7) % 7 || 7))
    at.setUTCHours(9, 0)
  } else if (preset === 'week') {
    at.setUTCDate(at.getUTCDate() + ((1 - at.getUTCDay() + 7) % 7 || 7))
    at.setUTCHours(8, 0)
  }
  return fromWall(at.toISOString().slice(0, 16))
}

const fmt = (date) => dateTimeText(date, { weekday: 'short', hour: 'numeric', minute: '2-digit' })

const CATEGORIES = [
  { value: 'inbox', label: 'Inbox', where: 'the Inbox', icon: 'tray', hint: 'Mail you answer' },
  { value: 'feed', label: 'Feed', where: 'the Feed', icon: 'newspaper', hint: 'Newsletters to read when you like' },
  { value: 'papertrail', label: 'Paper Trail', where: 'the Paper Trail', icon: 'receipt', hint: 'Receipts and notices to keep' },
  { value: 'spam', label: 'Spam', where: 'Spam', icon: 'warning-octagon', hint: 'Never in the Inbox' },
]
__fez_component_0 = class {
  PROPS = {
    container: { type: String, required: true },
    mailbox: String,
    team: Object,
    people: Array,
    labels: Array,
    on_team: { type: Function, state: true, default: () => {} },
    on_labels: { type: Function, state: true, default: () => {} },
  }

  init() {
    this.state.busy = false
    this.state.panel = ''
  }

  togglePanel(name) {
    this.state.panel = this.state.panel === name ? '' : name
  }

  // `later` is a preset or the picked datetime-local value.
  async snooze(later) {
    const at = later === 'pick' ? fromWall(this.state.pickInput.value) : snoozeTime(later)
    if (!(at > new Date())) return window.Toast?.error('Pick a time in the future')
    this.state.panel = ''
    await this.change('thread_snooze', { until: at.toISOString() })
  }

  unsnooze() {
    this.change('thread_snooze', { until: null })
  }

  async toggleLabel(ref) {
    const on = !this.props.team.labels.includes(ref)
    await window.App.api(`container/${this.props.container}/thread_label`, { thread: this.props.team.thread, mailbox: this.props.mailbox || undefined, label: ref, on }, { silent: true })
    const view = await window.App.api(`container/${this.props.container}/thread_activity`, { thread: this.props.team.thread, mailbox: this.props.mailbox || undefined }, { silent: true })
    this.state.on_team(view)
    this.state.on_labels()
  }

  async newLabel(event) {
    event.preventDefault()
    const name = this.state.labelInput.value.trim()
    if (!name) return
    const color = (this.props.labels.length % 8) + 1
    const label = await window.App.api(`container/${this.props.container}/label_save`, { mailbox: this.props.team.mailbox, name, color })
    this.state.labelInput.value = ''
    await this.toggleLabel(label.ref)
  }

  // `draft` shows at once and is put back on failure; without one the buttons stay busy until the answer.
  async change(action, params, draft) {
    const before = { ...this.props.team }
    if (draft) this.state.on_team({ ...before, ...draft })
    else this.state.busy = true
    try {
      const view = await window.App.api(`container/${this.props.container}/${action}`, { thread: this.props.team.thread, mailbox: this.props.mailbox || undefined, ...params }, { silent: true })
      this.state.on_team(view)
    } catch (error) {
      if (draft) this.state.on_team(before)
      window.Toast?.error(error.message)
    } finally {
      this.state.busy = false
    }
  }

  assign(event) {
    const assignee = event.target.value || null
    this.change('thread_assign', { assignee }, { assignee })
  }

  toggleDone() {
    this.change('thread_status', { status: this.props.team.status === 'done' ? 'open' : 'done' })
  }

  // Moves the conversation's sender, and with them this conversation.
  async moveSender(category) {
    const team = this.props.team
    this.state.panel = ''
    if (category === (team.decision === 'spam' ? 'spam' : team.category)) return
    this.state.busy = true
    try {
      await window.App.api(`container/${this.props.container}/sender_move`, { mailbox: team.mailbox, address: team.sender, decision: category }, { silent: true })
      const view = await window.App.api(`container/${this.props.container}/thread_activity`, { thread: team.thread, mailbox: this.props.mailbox || undefined }, { silent: true })
      window.Toast?.success(`Mail from ${team.sender} goes to ${CATEGORIES.find((item) => item.value === category).where}`)
      this.state.on_team(view)
    } catch (error) {
      window.Toast?.error(error.message)
    } finally {
      this.state.busy = false
    }
  }

  // The picker follows the shared assignee, whatever was picked before the answer came back.
  afterRender() {
    if (this.state.select) this.state.select.value = this.props.team?.assignee || ''
  }

  beforeRender() {
    const team = this.props.team
    this.state.ready = Boolean(team)
    if (!team) return
    const me = this.globalState.me?.email
    const people = [...this.props.people]
    if (team.assignee && !people.some((person) => person.email === team.assignee)) people.push({ email: team.assignee, name: team.assignee })
    this.state.options = people.map((person) => ({ value: person.email, label: person.email === me ? `${person.name} (you)` : person.name }))
    this.state.done = team.status === 'done'
    this.state.canClose = !team.assignee || team.assignee === me
    this.state.snoozedLabel = team.snoozed_until ? `Snoozed until ${dateTimeText(team.snoozed_until, { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })}` : ''
    this.state.presets = [
      { value: 'today', label: 'Later today', when: fmt(snoozeTime('today')) },
      { value: 'tomorrow', label: 'Tomorrow', when: fmt(snoozeTime('tomorrow')) },
      { value: 'weekend', label: 'This weekend', when: fmt(snoozeTime('weekend')) },
      { value: 'week', label: 'Next week', when: fmt(snoozeTime('week')) },
    ]
    this.state.movable = Boolean(team.sender) && team.category !== 'new'
    const current = team.decision === 'spam' ? 'spam' : team.category
    this.state.category = CATEGORIES.find((item) => item.value === current) || CATEGORIES[0]
    this.state.categories = CATEGORIES.map((item) => ({ ...item, on: item.value === current }))
    this.state.moveTitle = `Where mail from ${team.sender || 'this sender'} goes: ${this.state.category.label}`
    const on = new Set(team.labels || [])
    this.state.labelRows = this.props.labels.map((label) => ({ ...label, on: on.has(label.ref) }))
    this.state.chips = this.state.labelRows.filter((label) => label.on)
  }

  CSS = `:fez {
display:block;.team-bar{display:flex;flex-wrap:wrap;align-items:center;gap:var(--space-2)}.team-owner{display:inline-flex;align-items:center;gap:var(--space-1);padding:0 var(--space-1) 0 var(--space-2);border:1px solid var(--color-border);border-radius:var(--radius-md);background:var(--color-bg-raised);color:var(--color-text-muted);&:focus-within{border-color:var(--color-accent)}}.team-panel{flex:1 0 100%;display:grid;gap:2px;padding:var(--space-2)}.team-option{display:flex;align-items:center;gap:var(--space-2);padding:var(--space-1) var(--space-2);border:0;border-radius:var(--radius-md);background:transparent;color:var(--color-text);font:inherit;font-size:var(--text-sm);text-align:left;cursor:pointer;&:hover{background:var(--color-bg-hover)}}.team-panel-title{padding:var(--space-1) var(--space-2);overflow:hidden;color:var(--color-text-subtle);font-size:var(--text-xs);font-weight:var(--weight-semibold);text-overflow:ellipsis;white-space:nowrap}.team-option-when{margin-left:auto;color:var(--color-text-subtle);font-size:var(--text-xs)}.team-dot{width:10px;height:10px;flex:none;border-radius:var(--radius-full)}.team-pick{display:flex;gap:var(--space-2);padding:var(--space-1) var(--space-2) 0}.team-field{flex:1;min-width:0;height:30px;padding:0 var(--space-2);border:1px solid var(--color-border-strong);border-radius:var(--radius-md);background:var(--color-bg-raised);color:var(--color-text);font:inherit;font-size:var(--text-sm)}.team-chip{padding:1px var(--space-2);border:1px solid var(--chip);border-radius:var(--radius-full);color:var(--chip);font-size:var(--text-xs);font-weight:var(--weight-semibold)}.team-select{max-width:220px;height:30px;padding:0 var(--space-1);border:0;background:transparent;color:var(--color-text);font:inherit;font-size:var(--text-sm);cursor:pointer;&:focus{outline:0}}
}`

  HTML = `{#if state.ready}
<div class="team-bar">
<label class="team-owner" title="Who owns this conversation">
<ui-icon name="user-circle" size="16"></ui-icon>
<select class="team-select" aria-label="Assignee" fez:this="select" onchange="fez.assign(event)">
<option value="">Unassigned</option>
{#each state.options as option}
<option value={option.value}>{option.label}</option>
{/each}
</select>
</label>
{#each state.chips as chip}
<span class="team-chip" style="--chip: var(--color-avatar-{chip.color})">{chip.name}</span>
{/each}
<ui-button size="sm" variant="ghost" icon="tag" title="Labels" onclick="fez.togglePanel('labels')"></ui-button>
{#if state.movable}
<ui-button size="sm" variant="ghost" icon={state.category.icon} title={state.moveTitle} onclick="fez.togglePanel('category')"></ui-button>
{/if}
{#if state.snoozedLabel}
<ui-button size="sm" variant="ghost" icon="clock-counter-clockwise" label={state.snoozedLabel} title="Wake it now" :loading="state.busy" onclick="fez.unsnooze()"></ui-button>
{:else}
<ui-button size="sm" variant="ghost" icon="clock" title="Snooze" onclick="fez.togglePanel('snooze')"></ui-button>
{/if}
{#if state.done}
<ui-badge tone="success" label="Done"></ui-badge>
<ui-button size="sm" variant="ghost" icon="arrow-counter-clockwise" label="Reopen" :loading="state.busy" onclick="fez.toggleDone()"></ui-button>
{:else if state.canClose}
<ui-button size="sm" icon="check" label="Mark done" :loading="state.busy" onclick="fez.toggleDone()"></ui-button>
{/if}
{#if state.panel === 'snooze'}
<div class="ui-card team-panel" key="snooze" fez:in="slide, duration=140">
{#each state.presets as preset}
<button type="button" class="team-option" onclick="fez.snooze('{preset.value}')">{preset.label}<span class="team-option-when">{preset.when}</span></button>
{/each}
<div class="team-pick">
<input class="team-field" type="datetime-local" step="300" aria-label="Snooze until" fez:this="pickInput">
<ui-button size="sm" label="Snooze" onclick="fez.snooze('pick')"></ui-button>
</div>
</div>
{:else if state.panel === 'category'}
<div class="ui-card team-panel" key="category" fez:in="slide, duration=140">
<div class="team-panel-title">Mail from {props.team.sender} goes to</div>
{#each state.categories as item}
<button type="button" class="team-option" key={item.value} onclick="fez.moveSender('{item.value}')">
<ui-icon name={item.icon} size="16"></ui-icon>
{item.label}
<span class="team-option-when">{#if item.on}<ui-icon name="check" size="14"></ui-icon>{:else}{item.hint}{/if}</span>
</button>
{/each}
</div>
{:else if state.panel === 'labels'}
<div class="ui-card team-panel" key="labels" fez:in="slide, duration=140">
{#each state.labelRows as label}
<button type="button" class="team-option" key={label.ref} onclick="fez.toggleLabel('{label.ref}')">
<span class="team-dot" style="background: var(--color-avatar-{label.color})"></span>
{label.name}
<span class="team-option-when">{#if label.on}<ui-icon name="check" size="14"></ui-icon>{/if}</span>
</button>
{/each}
<form class="team-pick" onsubmit="fez.newLabel(event)">
<input class="team-field" placeholder="New label" aria-label="New label" maxlength="40" fez:this="labelInput">
<ui-button type="submit" size="sm" label="Add"></ui-button>
</form>
</div>
{/if}
</div>
{/if}`
};
}

Fez('mail-team-bar', __fez_component_0);

export default __fez_component_0;
